import { create } from 'zustand';

const STORAGE_KEY = 'sentinel.station';

function stored(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    // Storage blocked (private mode, policy): this device simply has no station.
    return null;
  }
}

interface ThisStationState {
  stationId: string | null;
  choose: (stationId: string | null) => void;
}

/** The station this browser sits at («Questa postazione», ADR 0026): kept on the device, not in
 *  the profile, because the same person works at the PCA today and at the COC tomorrow. */
export const useThisStation = create<ThisStationState>((set) => ({
  stationId: stored(),
  choose: (stationId) => {
    try {
      if (stationId === null) localStorage.removeItem(STORAGE_KEY);
      else localStorage.setItem(STORAGE_KEY, stationId);
    } catch {
      // Storage blocked: the choice lasts until the page is closed.
    }
    set({ stationId });
  },
}));
